import { ReactNode, DetailedHTMLProps, HTMLAttributes } from "react";
import classNames from "classnames";
import { Tooltip } from "antd";
import { HiInformationCircle } from "react-icons/hi";

// assets
import styles from "@/assets/styles/components/statistic-card.module.scss";

export interface IStatisticCard extends DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement> {
  className?: string;
  icon: ReactNode;
  label: ReactNode;
  value: ReactNode;
  fullWidth?: boolean;
  tooltipText?: string;
}

function StatisticCard({ icon, label, value, className = "", fullWidth, tooltipText, ...rest }: IStatisticCard) {

  const statisticCardClassName = classNames(
    styles["locl-statistic-card"],
    className,
    { [styles["locl-statistic-card_full-width"]]: fullWidth, }
  );

  return (
    <div className={statisticCardClassName} { ...rest }>
      <span className={styles["locl-statistic-card__label"]} data-testid="locl-statistic-card-label">
        { label }
        {
          tooltipText && (
            <Tooltip
              align={{ offset: [0, -7] }}
              overlayClassName={styles["locl-statistic-card__tooltip"]}
              title={tooltipText}
            >
              <HiInformationCircle className={styles["locl-statistic-card__tooltip-icon"]} />
            </Tooltip>
          )
        }
      </span>
      <div className={styles["locl-statistic-card__body"]}>
        <div className={styles["locl-statistic-card__icon"]}>
          { icon }
        </div>
        <span className={styles["locl-statistic-card__value"]} data-testid="locl-statistic-card-value">{ value || "-" }</span>
      </div>
    </div>
  );
}

export default StatisticCard;
